import { Modal, Tag } from "antd";
import { useMemo } from "react";

const formatDate = (raw) => {
  if (!raw) return null;
  try {
    return new Date(raw).toLocaleString("fa-IR");
  } catch {
    return raw;
  }
};

const dedupeAnswers = (answers) => {
  if (!Array.isArray(answers)) return [];
  const seen = new Map();
  for (const a of answers) {
    const key = a?.question?.id ?? a?.question?.label ?? Math.random();
    const prev = seen.get(key);
    if (!prev || (a?.id ?? 0) > (prev?.id ?? 0)) {
      seen.set(key, a);
    }
  }
  return Array.from(seen.values());
};

const SessionBlock = ({ session, index, total }) => {
  const answerQuestions = useMemo(
    () => dedupeAnswers(session?.answer_questions),
    [session],
  );
  const formKey = answerQuestions[0]?.form?.key;
  const isWhoAndWhere = formKey === "whoandwhere";

  const resultLink = useMemo(() => {
    if (!isWhoAndWhere) return null;
    const params = answerQuestions
      .map(
        (answer) =>
          `${answer.question?.id}=${encodeURIComponent(answer.value ?? "")}`,
      )
      .join("&");
    return `https://planium.ir/WhoAndWhere?result=1&${params}`;
  }, [answerQuestions, isWhoAndWhere]);

  const infoFields = [
    { label: "کمپین", value: session?.utm_campaign },
    { label: "سورس", value: session?.utm_source },
    { label: "مدیوم", value: session?.utm_medium },
    { label: "ریفرر", value: session?.utm_referrer ?? session?.referrer },
    { label: "لندینگ", value: formKey },
    { label: "تاریخ", value: formatDate(session?.createdAt) },
  ];

  return (
    <div
      style={{
        marginBottom: 12,
        padding: 12,
        border: "1px solid #d9d9d9",
        borderRadius: 4,
        background: "#fafafa",
      }}
    >
      {total > 1 && (
        <div style={{ marginBottom: 8 }}>
          <Tag color={index === 0 ? "green" : "default"}>
            ثبت {total - index} از {total}
            {index === 0 ? " (جدیدترین)" : ""}
          </Tag>
        </div>
      )}
      <div style={{ marginBottom: 8 }}>
        {infoFields.map(({ label, value }) => (
          <div key={label} style={{ marginBottom: 4 }}>
            <span>{label}: </span>
            <b>{value || "—"}</b>
          </div>
        ))}
      </div>
      {isWhoAndWhere && resultLink && (
        <>
          <hr />
          <div style={{ marginBottom: 8 }}>
            <a href={resultLink} target="_blank" rel="noopener noreferrer">
              مشاهده نتیجه تست
            </a>
          </div>
        </>
      )}
      {answerQuestions.length > 0 && (
        <>
          <hr />
          {answerQuestions.map((item) => (
            <div
              key={item.id ?? item.question?.id ?? item.question?.label}
              style={{ marginBottom: 4 }}
            >
              <span>{item.question?.label}: </span>
              <b>{item.value || item.question_option?.label || "—"}</b>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

const LeadInfoModal = ({ info, loading, onClose }) => {
  const sessions = useMemo(() => {
    if (Array.isArray(info?.sessions) && info.sessions.length > 0) {
      return info.sessions;
    }
    if (info?.sessionInfo) return [info.sessionInfo];
    return [];
  }, [info]);

  return (
    <Modal
      title={`اطلاعات بیشتر لید${sessions.length > 1 ? ` (${sessions.length} ثبت)` : ""}`}
      open={info != null}
      destroyOnClose
      confirmLoading={loading}
      cancelText="بستن"
      onCancel={onClose}
      footer={null}
      width={640}
    >
      <hr />
      {sessions.length === 0 ? (
        <div>اطلاعات بیشتری موجود نیست</div>
      ) : (
        sessions.map((session, i) => (
          <SessionBlock
            key={session?.id ?? i}
            session={session}
            index={i}
            total={sessions.length}
          />
        ))
      )}
    </Modal>
  );
};

export default LeadInfoModal;
